<template>
  <el-container class="OperatLayout a6a90310">
    <el-header class="header" v-show="!uiHiddenState.isHiddenNav">
      <globalTopNav :routes="filterRoute" :query="query" :mapName="mapName" ref="topNav">
        <div class="mapNameLooker" slot="mapNameLooker">
          <el-tooltip
            v-if="!shared && !isTemplate"
            content="返回"
            placement="top"
            effect="light"
            :open-delay="1000"
          >
            <div class="img" @click="$router.push('/controlPlatform')">
              <img src="~@/assets/images/go-right.svg" />
            </div>
          </el-tooltip>
          <span>{{ mapName }}</span>
        </div>
        <el-button
          @click="goBack"
          slot="btn"
          class="backBtn"
          v-if="!shared && !isTemplate"
        >
          <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
            <use xlink:href="#icon-fanhui1"></use>
          </svg>
          返回
        </el-button>
      </globalTopNav>
    </el-header>
    <el-main class="main no-padding">
      <div class="aw ah" style="position: relative">
        <cesiumViewer
          class="cesium-viewer"
          ref="cesiumViewer"
          @cesiumMsg="onCesiumMsg"
          @selectPrimitive="onSelectPrimitive"
          @showSppucTw="onShowSppucTw"
        ></cesiumViewer>
        <div v-if="routerAlive">
          <SearchList
            class="shared"
            ref="searchList"
            @selectedPoi="onSelectPoi"
            :style="{ left: !layerListShow ? 'var(--no-left)' : undefined }"
          ></SearchList>
          <PoiDetail ref="poiDetail"></PoiDetail>
          <livePreview ref="livePreview"></livePreview>
          <PreviewPicture ref="previewPicture"></PreviewPicture>
          <MarkerDetail
            ref="markerDetail"
            @livePreviewMsg="openLivePreview"
            @previewPicMsg="onPreviewPic"
            @selectPrimitive="onSelectPrimitive"
            @showHTMLEditorMsg="onShowHTMLEditor"
          ></MarkerDetail>
          <volumeMeasureBox ref="volumeMeasureBox"></volumeMeasureBox>
          <!--  可视域分析操作弹窗-->
          <viewShed3DBox ref="viewShed3DBox"></viewShed3DBox>
          <MarkerAttributeEditor ref="markerAttributeEditor" :readonly="!!shared"></MarkerAttributeEditor>
          <transition name="el-fade-in-linear">
            <router-view />
          </transition>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import GlobalTopNav from '@/components/GlobalTopNav/GlobalTopNav'
import cesiumViewer from '@/components/cesiumViewer'
import livePreview from '@/components/live-preview'
import PreviewPicture from '@/components/PreviewPicture/PreviewPicture'
import PoiDetail from '../views/operatingPlatform/Marker/components/PoiDetail'
import SearchList from '../views/operatingPlatform/components/POISearch/SearchList'
import MarkerDetail from '@/views/operatingPlatform/Marker/components/MarkerDetail'
import volumeMeasureBox from '@/views/operatingPlatform/Marker/components/volumeMeasureBox'
import viewShed3DBox from '@/views/operatingPlatform/Marker/components/viewShed3DBox'
import MarkerAttributeEditor from '@/components/MarkerAttributeEditor'
import routes from '../router/routes'
import { mapActions, mapGetters } from 'vuex'
import { getMapDetails } from '@/api/mapManagement'
import { getMapModel } from '@/api/marker'
import { treeForeach } from '@/utils/tree'
import { PermissionLevel } from '@/configs/constants'
import { getMapStyle } from '@/api/mapStyle'

// eslint-disable-next-line no-unused-vars
import axios from '@/utils/request'
import ShareUtil from '@/utils/share'

export default {
  name: 'OperatLayout',
  props: {},
  components: {
    GlobalTopNav,
    cesiumViewer,
    PoiDetail,
    SearchList,
    livePreview,
    PreviewPicture,
    MarkerDetail,
    volumeMeasureBox,
    viewShed3DBox,
    MarkerAttributeEditor
  },
  inject: ['shared', 'templateShared'],
  data () {
    return {
      routerAlive: true,
      // routes: routes[1].children,
      query: undefined,
      mapName: '',
      tilesetOptions: {
        maximumScreenSpaceError: undefined,
        maximumMemoryUsage: undefined
      }
    }
  },
  provide () {
    const propertyFn = {
      cesiumViewer: () => {
        return this.$refs.cesiumViewer
      },
      operatLayout: () => {
        return this
      }
    }
    const refresh = this.refresh
    return new Proxy(
      {
        /**
         * 由于当前代码的逻辑顺序问题，子页面中使用 inject: ['cesiumViewer']  时，如果在 mounted 中使用
         *
         * @example
         *   // 在 mounted 中使用
         *   async mounted () {
         *      await this.$nextTick()
         *      console.log(this.cesiumViewer)
         *    }
         *  // 正常使用
         *  this.cesiumViewer
         */
        cesiumViewer: undefined,
        operatLayout: undefined,
        refresh
      },
      {
        get: function (target, property) {
          const fn = propertyFn[property]
          return fn ? fn(target) : target[property]
        }
      }
    )
  },
  computed: {
    layerListShow () {
      return (
        !this.shared ||
        !/^marker$/i.test(this.$route.name) ||
        new ShareUtil().show('layerListShow')
      )
    },
    filterRoute () {
      let temp = []
      temp = routes[1].children
      if (this.isTemplate) {
        temp = temp.filter(({ meta }) => meta.enableTemplate)
      }
      const util = new ShareUtil()
      // 添加了分享页面控制
      if (this.shared) {
        temp = temp.filter(
          ({ meta }) => meta?.shareKey && util.show(meta.shareKey)
        )
      }
      return temp
    },
    ...mapGetters([
      'userId',
      'selectedMarker',
      'isTemplate',
      'permissionLevel',
      'volumeMeasureMarker',
      'viewShed3DData',
      'uiHiddenState'
    ])
  },
  watch: {
    selectedMarker (val, oldVal) {
      if (val) {
        this.showMarkerDetail(true, val)
        // this.$store.dispatch('showRight', false)
        // this.$store.dispatch('showLeft', false)
      } else {
        // this.$store.dispatch('showLeft', true)
        // if (this.selectedLayer) {
        //   this.$store.dispatch('showRight', true)
        // }
        if (this.$refs.markerDetail.visible) {
          this.showMarkerDetail(false)
        }
      }
    },
    volumeMeasureMarker (val) {
      if (val) {
        this.$refs.volumeMeasureBox.open(val)
      } else {
        if (this.$refs.volumeMeasureBox.isShow) {
          this.$refs.volumeMeasureBox.close()
        }
      }
    },
    viewShed3DData (val) {
      if (val) {
        this.$refs.viewShed3DBox.open()
      } else {
        if (this.$refs.viewShed3DBox.isShow) {
          this.$refs.viewShed3DBox.close()
        }
        this.$cesiumPlus.viewShed3D.remove()
      }
    },
    $route (to, from) {
      this.$emit('selectedPoi', undefined)
      this.$store.commit('SET_SEARCH_PARAMS', {})
      if (this.$refs.markerDetail.visible) {
        this.showMarkerDetail(false)
      }
      if (this.$refs.previewPicture) {
        this.$refs.previewPicture.close()
      }
      if (this.$refs.viewShed3DBox.isShow) {
        this.$refs.viewShed3DBox.close()
      }
      if (this.$refs.volumeMeasureBox.isShow) {
        this.$refs.volumeMeasureBox.close()
      }
    }
  },
  created () {
    // 设置分享标识
    if (this.shared) {
      axios.defaults.headers.share = this.shared
    }
    if (this.templateShared) {
      axios.defaults.headers.templateShare = this.templateShared
    }

    this.mapId = this.$route.query.mapId
    if (!this.mapId) {
      this.mapId = 0
    }
    // this.setCurMapId(this.mapId)
    this.query = this.$route.query
    this.$store.commit('SET_CURMAP', this.mapId)
    this.$store.commit('SET_ISTEMPLATE', !!this.$route.query.template)
    if (this.$route.query.template) {
      this.$store.commit('SET_PERMISSION_LEVEL', PermissionLevel.ANONYM)
    }

    this.$store.dispatch('getLayerTree')
    this.$store.dispatch('getMarkerIcons')
    // this.$store.dispatch('getLayerList', { refreshMarker: true })
    this.$store.dispatch('getDefaultViewPoint')
    this.$store.dispatch('getFrequentlyViewPoint')

    // 读取图层可见性
    let layerVisibleStorage = {}
    const storege = localStorage.getItem('layerVisible' + this.userId)
    if (storege && !this.isTemplate) {
      layerVisibleStorage = JSON.parse(storege)
    }
    // if (this.layerVisibleStorage && this.layerVisibleStorage[this.mapId]) {
    //   this.layerVisible = this.layerVisibleStorage[this.mapId]
    // }
    this.$store.commit('SET_LAYER_VISIBLE', layerVisibleStorage)
  },
  async mounted () {
    await this.getMapStyle()
    await this.loadMapModel()
    await this.getLayerList()
    await this.getMarkerList()
    document.getElementById('cesiumViewer').onclick = () => {
      this.$refs.topNav.hideNotice()
    }
  },
  destroyed () {
    this.$store.commit('destroyAllDatasets')
    this.$store.commit('resetMapState')
  },
  methods: {
    async refresh () {
      this.routerAlive = false
      await this.$nextTick()
      this.routerAlive = true
    },
    ...mapActions(['setCurMapId', 'getLayerList', 'getMarkerList']),
    // 选择poi搜索结果
    onSelectPoi (data) {
      if (data) {
        this.$refs.poiDetail.show(data)
      } else {
        this.$refs.poiDetail.close()
      }
    },
    onCesiumMsg (type, data) {
      if (type === 'selectPoiMarker') {
        this.$refs.searchList.selectPoiById(data)
      }
    },
    goBack () {
      this.$router.push({
        name: 'MapManagement',
        params: { isTemplate: this.isTemplate }
      })
    },
    // 直播预览
    openLivePreview (data) {
      this.$refs.livePreview.open(data)
    },
    // 图片预览
    onPreviewPic (data) {
      this.$refs.previewPicture.open(data.list, data.index)
    },
    // 获取地图样式设置
    async getMapStyle () {
      const res = await getMapStyle({ mapId: this.$route.query.mapId })
      if (res.code === 200 && res.data) {
        // 地图底图
        await this.$cesiumPlus.imageryManager.switchBaseLayer(
          CesiumPlus.LayerDefine[res.data.mapStyle]
        )
        if (res.data.labelLayer) {
          this.$cesiumPlus.imageryManager.switchLabelLayer(
            CesiumPlus.LayerDefine[res.data.labelLayer]
          )
        }

        // 地图亮度
        this.$cesiumPlus.imageryManager.getBaseLayer().brightness =
          res.data.mapBrightness * 0.1
        // 模型亮度
        const brightnessStage = this.$brightnessStage
        brightnessStage.uniforms.brightness = res.data.modelBrightness * 0.1
        // if (this.$cesiumPlus.viewer.scene.postProcessStages.length <= 0) {
        //   this.$cesiumPlus.viewer.scene.postProcessStages.add(brightnessStage)
        // }
        this.$store.commit('SELECT_MODELHEIGHT', res.data.modelHeight)
        // 3dTileset属性
        this.tilesetOptions = {
          maximumScreenSpaceError: res.data.maximumScreenSpaceError,
          maximumMemoryUsage: res.data.maximumMemoryUsage
        }
      }
    },
    async loadMapModel () {
      const res = await getMapDetails({ id: this.mapId })
      this.$store.commit('SET_MAP_INFO', res.data)

      this.mapName = res.data.name

      const { areaId } = res.data
      // 在url上更新区域id
      this.$router.replace({
        query: {
          ...this.$route.query,
          areaId
        }
      })

      const res2 = await getMapModel({ id: res.data.areaId })
      if (res2.code === 200 && res2.data) {
        if (res2.data.model) {
          this.$refs.cesiumViewer.loadServerRes(res2.data.model.link, Object.assign(res2.data.model, this.tilesetOptions))
        }
        if (res2.data.children && res2.data.children.length) {
          treeForeach(res2.data.children, 'children', (item) => {
            if (item && item.model) {
              this.$refs.cesiumViewer.loadServerRes(item.model.link, Object.assign(item.model, this.tilesetOptions))
            }
          })
        }
      }
    },
    showMarkerDetail (isShow, data) {
      if (isShow) {
        this.$refs.markerDetail.show(data)
      } else {
        this.$refs.markerDetail.close()
      }
    },
    onSelectPrimitive (data) {
      if (!data) {
        const selectedPrimitiveId = this.$refs.cesiumViewer.selectedPrimitiveId
        if (
          selectedPrimitiveId &&
          selectedPrimitiveId.startsWith('billboard-')
        ) {
          const ids = selectedPrimitiveId.replace('billboard-', '').split('-')
          // const [layerId, id] = ...ids
          const bundle = this.$cesiumPlus.primitiveManager.getBundle(ids[0])
          if (!bundle) {
            console.error('can not find bundle, ', ids[0])
            return
          }
          const billboard = bundle.getBillboard(selectedPrimitiveId)
          if (billboard) {
            billboard.scale = bundle.style._scale
          }
        }
        this.$refs.cesiumViewer.selectedPrimitiveId = undefined
        if (this.$refs.markerDetail.visible) {
          this.showMarkerDetail(false)
        }
        return
      }
      const layerId = data.layerId
      const bundle = this.$cesiumPlus.primitiveManager.getBundle(layerId)
      if (!bundle) {
        console.error('can not find bundle, ', layerId)
        return
      }
      const billboardId = `billboard-${layerId}-${data.id}`
      const primitive = bundle.getBillboard(billboardId)
      if (!primitive) {
        return
      }
      this.$cesiumPlus.cameraManager.zoomToPosition(primitive.position)
      bundle.forEach((billboard) => {
        billboard.scale =
          billboard.id === primitive.id ? 1.5 : bundle.style._scale
      })
      this.$refs.cesiumViewer.selectedPrimitiveId = primitive.id

      this.showMarkerDetail(true, {
        dataSourceType: 'API',
        ...data
      })
    },
    // 显示图文弹窗
    onShowHTMLEditor (data) {
      this.$refs.markerAttributeEditor.show({
        ...data
      })
    },
    async onShowSppucTw (data) {
      this.$refs.videoView.show(data)
      await this.$nextTick()
      this.$refs.cesiumViewer.sppucManager.callVideo(data.deviceId)
      this.curId = data.deviceId
      this.$store.dispatch('setDrawState', true)
    },
    onCloseVideo () {
      this.$refs.cesiumViewer.sppucManager.endVideo(this.curId)
      this.curId = undefined
      this.$store.dispatch('setDrawState', false)
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.OperatLayout.a6a90310 {
  width: 100%;
  height: 100%;
  .el-header {
    height: 48px !important;
    background: #272829;
    box-sizing: border-box;
    border-bottom: 1px solid #000000;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .backBtn {
      background: #373839 !important;
      border: 0 !important;
      position: relative;
      // margin-right: 10px;
      // &:before {
      //   content: '';
      //   display: inline-block;
      //   position: absolute;
      //   height: 90%;
      //   width: 1px;
      //   background-color: #434445;
      //   right: -15px;
      //   top: 2px;
      // }
    }
    .line {
      width: 1px;
      height: 28px;
      background: rgba(255, 255, 255, 0.1);
    }
    .left {
      .el-select {
        width: 200px;
      }
    }
    .center {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: start;
      padding-left: 10px;
      box-sizing: border-box;
      .nav {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.3);
        font-family: Source Han Sans SC;
        font-weight: 300;
        cursor: pointer;
        margin-left: 10px;
        transition: all 0.3s;
        &:hover {
          color: #ffffff;
        }
        &.active {
          color: #ffffff;
        }
      }
    }
    .right {
      width: 260px;
      height: 100%;
      padding-left: 57px;
      padding-right: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
    }
  }
}
</style>

<style lang="scss" scoped>
.header {
  height: 48px !important;
  width: 100%;
  background: #272829;
  box-sizing: border-box;
  border-bottom: 1px solid #000000;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main {
  position: relative;
  overflow: hidden;
}
.shared {
  --no-left: 10px;
}
</style>
